/* eslint-disable camelcase */
import React, { useEffect, useState } from 'react';
import { FormSelect } from "react-bootstrap";
import apiCalls from '../PowerShadesAPIFunctions';

const ChannelSelect = (props) => {
	const [channels, setChannels] = useState([]);

	const { channelsOverride, bootstrap, noLabel, title, channel_id, onChange } = props;

	useEffect(() => {
		if (channelsOverride) {
			setChannels(channelsOverride);
		} else if (!channelsOverride) {
			apiCalls.listChannelTypes().then((resp) => {
				setChannels(resp && resp.data && resp.data.channels);
			});
		}
	}, [channelsOverride]);

	const options = channels
		? channels.map((c) => (
			<option key={c.id} value={c.id} title={c.description}>
				{c.name}
			</option>
		))
		: null;

	return (
		!options || options.length === 0 ? null : (
			<div style={!bootstrap ? { flexGrow: "1", maxWidth: "20%" } : null}>
				{noLabel ? null : (
					<>
						<label>
							{title ? `${title} Channel` : "Channel"}
						</label>
						<br />
					</>
				)}
				{bootstrap
					? (
						<FormSelect
							className="full-width"
							size="sm"
							value={channel_id}
							onChange={(e) => onChange(parseInt(e.target.value, 10))}
						>
							{options}
						</FormSelect>
					)
					: (
						<select
							value={channel_id}
							onChange={(e) => onChange(parseInt(e.target.value, 10))}
						>
							{options}
						</select>
					)}
					
			</div>
		)
	);
};

export default ChannelSelect;
